import en from './en.json';

const defaultLocale = 'en';

const languages = {
  en: en,
}

export { defaultLocale, languages };